// src/modules/ida/hooks/useOnboardingExitRefresh.ts
//
// Task #51 (#1167-v2): GUARANTEED onboarding-header clearing, signal-independent.
//
// #1167 refreshes onboarding config on the refresh_workspace job-completion
// signal -- but that signal only fires if the onboarding agent actually calls
// update_workspace_settings (LLM/tool-selection behavior, not guaranteed). When
// the agent persists settings some other way (or a later turn flips
// needs_onboarding), the refresh_workspace signal never fires and the FE keeps
// sending a stale X-Onboarding-Mode header until a remount.
//
// This hook closes that tail: whenever an assistant turn SETTLES (isLoading
// 1->0) while onboarding is still active, refetch onboarding config. It fires
// after ANY onboarding turn regardless of which tools the agent called, so it
// cannot be agent-tool-gated. Once needs_onboarding flips false server-side the
// refetch clears it, needsOnboarding goes false, and the hook stops firing.

import { useEffect, useRef } from "react";

export function useOnboardingExitRefresh(
  isLoading: boolean,
  needsOnboarding: boolean,
  refreshOnboardingConfig: () => void,
): void {
  const prevIsLoadingRef = useRef(isLoading);
  useEffect(() => {
    const prevIsLoading = prevIsLoadingRef.current;
    prevIsLoadingRef.current = isLoading;

    // Only on a turn SETTLING (true -> false) AND while still onboarding.
    if (prevIsLoading && !isLoading && needsOnboarding) {
      refreshOnboardingConfig();
    }
  }, [isLoading, needsOnboarding, refreshOnboardingConfig]);
}
